module.exports = __webpack_public_path__ + "static/images/map/markers/pin_09A129.svg";